"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const app_1 = require("app");
const KeepTheRhythm_1 = require("../KeepTheRhythm");
class TileGroupService {
    constructor(apiUrl, isPaginated) {
        this.apiUrl = apiUrl;
        this.isPaginated = isPaginated;
        this.fetchTiles = (params) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield (0, app_1.apiPost)(this.apiUrl, params);
            return response.data;
        });
        this.createURLKeyValueQueryParams = (currentPage, tilesPerPage) => {
            return this.isPaginated ? `page:${currentPage},pageSize:${tilesPerPage}` : '';
        };
        this.resetKTR = () => {
            KeepTheRhythm_1.KTR.SetPendingUpdate();
            app_1.ComponentService.UpdateComponentsSelector();
        };
    }
}
exports.default = TileGroupService;
